import { eTipoPermissao } from '@/enums/ePermissoes';
export default [
    {
        description: 'Área de Interesse',
        path: '/biblioteca/bibareainteresse',
        name: 'bibareainteresse',
        component: () => import('@/views/biblioteca/bibareainteresse/Index.vue'),
        meta: {
            permissions: [eTipoPermissao.BIB_AREADEINTERESSENOVO_MENU_1300801799],
        },
        goesToMenu: true,
    },
    {
        description: 'Cadastro de Areas de Interesse',
        path: '/biblioteca/bibareainteresse/cadastro/:id?',
        parent: 'bibareainteresse',
        name: 'bibareainteresse_create',
        component: () => import('@/views/biblioteca/bibareainteresse/InclusaoEdicao.vue'),
        meta: {
            permissions: [eTipoPermissao.BIB_AREADEINTERESSENOVO_MENU_1300801799],
        },
        goesToMenu: true,
    },
]
